import { gql } from "lib/apolloClient";
import { studentsAlertFragment } from "modules/CommonFragments";

// TODO: confirm fetching email won't cause issues in Messaging
const basicUserFragment = gql`
  fragment userDetailItem on User {
    id
    email
    firstName
    lastName
    middleName
    type
    profileImage

    ... on Student {
      email
      isArchived
      isDeleted
      preferredName
      prefix
      pronouns
      suffix
      yearGroup {
        id
        grade {
          id
          name
        }
        curriculumProgram {
          id
          label
        }
      }
      sourceId
      alertTypes {
        ...alertTypeFields
      }
    }

    ... on Staff {
      isArchived
      isDeleted
      displayRole
      role
      preferredName
      prefix
      suffix
      pronouns
      yearGroups {
        id
        curriculumProgram {
          id
          label
        }
      }
      curriculumPrograms {
        id
        label
      }
    }

    ... on FamilyMember {
      preferredName
      prefix
      pronouns
      suffix
      children(organizationId: $organizationId) {
        id
        email
        firstName
        lastName
        middleName
        preferredName
        prefix
        pronouns
        suffix
        sourceId
      }
    }
    ... on Parent {
      preferredName
      prefix
      pronouns
      suffix
      children {
        id
        email
        firstName
        lastName
        middleName
        preferredName
        prefix
        pronouns
        suffix
        sourceId
      }
    }
  }
  ${studentsAlertFragment}
`;

// All the common fragments for manage members
export const manageMembersFragments = {
  basicUserItem: basicUserFragment,
  userItem: gql`
    fragment userItem on User {
      ...userDetailItem

      ... on Student {
        sourceId
        isArchived
        isDeleted
        preferredName
        pronouns
        prefix
        suffix

        yearGroup {
          id
          grade {
            id
            name
          }
          curriculumProgram {
            id
            label
          }
        }

        familyMembers @include(if: $getStudentFamilyMembers) {
          id
          email
          firstName
          lastName
          middleName
          type
          profileImage
          preferredName
          pronouns
          suffix
          prefix

          children(organizationId: $organizationId) {
            id
            email
            firstName
            lastName
            middleName
            preferredName
            pronouns
            suffix
            prefix
            sourceId
          }
        }
      }
    }
    ${basicUserFragment}
  `,
};
